import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = {
  class: "wrapper-top-left"
};
const _hoisted_3 = {
  class: "card-header"
};
const _hoisted_4 = {
  class: "collapse"
};
const _hoisted_5 = {
  class: "collapse-title"
};
const _hoisted_6 = {
  class: "collapse-btn"
};
const _hoisted_7 = {
  class: "wrapper-top-right"
};
import DialogAssetsLib from '@/views/AssetsLib/DialogAssetsLib';
import PrintedItem from './PrintedItem';
import PrintedTimeline from "./PrintedTimeline";
import { onMounted, reactive, ref } from "vue";
import { ElMessage } from 'element-plus';
import apis from "@/api";
import PrintedUpload from "@/components/Upload";
import { useRouter } from "vue-router";
export default {
  __name: 'Add',
  setup(__props) {
    const router = useRouter();
    const dialogVisible = ref(false);
    const uploadVisible = ref(false);
    const tags = ref([]);
    const activeAsset = ref(null);
    const printedLoading = ref(false);
    const fileTypes = ref(['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']);
    const data = reactive({
      // 源数据
      printedAssets: [],
      printedDemand: {
        listDetail: []
      },
      disabled: false
    });
    onMounted(() => {
      dialogVisible.value = true;
      queryPrintedTags();
    });

    // 标签查询
    const queryPrintedTags = () => {
      const param = {
        pageNo: 1,
        pageSize: 50,
        parNum: 'printed-types'
      };
      printedLoading.value = true;
      apis.queryTagByParNum(param).then(res => {
        if (res && res.success) {
          res.data.records.forEach(item => {
            const tag = {
              name: item.tagNum,
              label: item.tagName
            };
            tags.value.push(tag);
          });
        } else {
          ElMessage.error(res.msg);
        }
        printedLoading.value = false;
      }).catch(err => {
        ElMessage.error(err);
        printedLoading.value = false;
      });
    };
    const handleSelectedChange = assets => {
      data.disabled = false;
      dialogVisible.value = false;
      data.printedAssets = data.printedAssets.concat(assets);
      if (data.printedAssets && data.printedAssets.length > 0) {
        activeAsset.value = data.printedAssets[0].id;
      }
    };
    const dialogClose = () => {
      dialogVisible.value = false;
    };
    const handleSelectAssets = () => {
      dialogVisible.value = true;
    };

    // 印刷品素材提交函数
    const handleSubmit = () => {
      if (data.printedAssets.length === 0) {
        ElMessage.error("请先选择需要印刷的素材文件！");
        return;
      }
      let valid = false;
      data.printedAssets.some(item => {
        if (!item.types || item.types.length === 0) {
          const msg = `请选择【${item.assetsName}】印刷品类`;
          ElMessage.error(msg);
          return false;
        }
        if (!item.dateRange || item.dateRange.length === 0) {
          const msg = `请选择【${item.assetsName}】印刷品投放日期`;
          ElMessage.error(msg);
          return false;
        }
        valid = true;
      });
      if (!valid) {
        return;
      }
      data.printedAssets.forEach((item, index) => {
        data.printedDemand.listDetail.push({
          "imageUrl": item.srcInnUrl,
          "tagList": item.types,
          "startDate": item.dateRange[0],
          "endDate": item.dateRange[1],
          "des": item.desc,
          "imageName": item.assetsName,
          "imageId": item.id
        });
      });
      apis.addPressworkInfo(data.printedDemand).then(res => {
        if (res && res.success) {
          ElMessage({
            message: '提交成功!',
            type: 'success'
          });
          router.push("/my-needs/list");
        } else {
          ElMessage.error(res.msg);
        }
      }).catch();
    };

    // 删除已选素材
    const removeAssets = index => {
      data.printedAssets.splice(index, 1);
    };

    // 下载模板
    const downloadTemplateFile = () => {
      window.open("/filesvc/xw-assets/市场经营部印刷品需求填报(需求模板).xlsx");
    };
    const downloadFile = () => {
      window.open(data.printedDemand.fileUrl);
    };
    const handlerUploadSuccess = files => {
      uploadVisible.value = false;
      if (files && files.length > 0) {
        const file = files[0];
        data.printedDemand.fileId = file.id;
        data.printedDemand.fileName = file.fileName;
        data.printedDemand.fileUrl = file.innerUrl;
      } else {
        ElMessage.error('请先上传印刷品附件!');
      }
    };
    const uploadFile = () => {
      uploadVisible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_row = _resolveComponent("el-row");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 24,
        class: "wrapper-top"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_card, {
          class: "wrapper-top-left-card",
          shadow: "hover"
        }, {
          header: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "新增印刷品制作需求", -1)), _createVNode(_component_el_button, {
            type: "primary",
            link: "",
            onClick: _withModifiers(handleSelectAssets, ["stop"])
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("选择素材文件", -1)]))]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_collapse, {
            modelValue: activeAsset.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeAsset.value = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.printedAssets, (item, index) => {
              return _openBlock(), _createBlock(_component_el_collapse_item, {
                key: index,
                name: item.id
              }, {
                title: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(item.assetsName), 1)]), _createElementVNode("div", _hoisted_6, [!data.disabled ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "danger",
                  size: "small",
                  circle: "",
                  link: "",
                  onClick: _withModifiers($event => removeAssets(index), ["stop"])
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 删除 ", -1)]))]),
                  _: 1
                }, 8, ["onClick"])) : _createCommentVNode("", true)])])]),
                default: _withCtx(() => [_createVNode(_unref(PrintedItem), {
                  disabled: data.disabled,
                  asset: item,
                  tags: tags.value
                }, null, 8, ["disabled", "asset", "tags"])]),
                _: 2
              }, 1032, ["name"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_card, {
          shadow: "hover"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, null, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "需求流程"
            }, {
              default: _withCtx(() => [_createVNode(_unref(PrintedTimeline), {
                class: "wrapper-top-right-timeline"
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "wrapper-file"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("span", {
            style: {
              "color": "red"
            }
          }, "*", -1)), _cache[7] || (_cache[7] = _createElementVNode("span", null, "印刷品制作附件:", -1)), _createElementVNode("span", {
            class: "span-btn",
            onClick: downloadTemplateFile
          }, "下载模版"), data.printedDemand.fileName ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "span-btn",
            onClick: downloadFile
          }, _toDisplayString(data.printedDemand.fileName), 1)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "span-btn",
            onClick: uploadFile
          }, "上传附件"))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "wrapper-btn"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          disabled: data.disabled,
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("提交审核", -1)]))]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, null, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("取消", -1)]))]),
          _: 1
        })]),
        _: 1
      })])), [[_directive_loading, printedLoading.value]]), _createVNode(_unref(DialogAssetsLib), {
        visible: dialogVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        title: "请先选择制作印刷品的素材图片",
        onClose: dialogClose,
        onSelectedChange: handleSelectedChange
      }, null, 8, ["visible"]), _createVNode(_unref(PrintedUpload), {
        visible: uploadVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => uploadVisible.value = $event),
        "file-types": fileTypes.value,
        onUploadSuccess: handlerUploadSuccess
      }, null, 8, ["visible", "file-types"])], 64);
    };
  }
};